import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, map } from 'rxjs';
import { RoleResponse } from '../../../models/Role/role.model';
import { role_urls } from '../Constants/api-constants';
import { HttpRes } from '../../../models/common/http.model';

import { environment } from '../../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
  observe: 'response' as 'response',
};

@Injectable({
  providedIn: 'root',
})
export class RoleServiceService {
  constructor(private readonly httpClient: HttpClient) {}

  roleDetail: any;
  durationInSeconds: number = 3000;
  /** Same session keys as `RegServicService` / travel switch helpers. */
  private getSwitchUserRoleIdForQuery(): string {
    if (!globalThis.window?.sessionStorage) {
      return '';
    }
    const raw =
      sessionStorage.getItem('switch_user_role_id') ||
      sessionStorage.getItem('switch_user_id') ||
      '';
    if (raw === '' || raw === '-1') {
      return '';
    }
    const n = Number.parseInt(raw, 10);
    if (Number.isNaN(n) || n < 0) {
      return '';
    }
    return raw;
  }

  getRoles(
    role_ids = 0,
    page_num = 0,
    per_page = 0,
    join_verifiers = false,
    join_parents = false,
    role_fields = false,
    is_active = false,
    is_login = false,
    source: string | null = null,
  ): Observable<RoleResponse> {
    let params = new HttpParams();

    if (role_ids > 0) {
      params = params.set('role_ids', role_ids.toString());
    }
    if (page_num > 0) {
      params = params.set('page_num', page_num.toString());
    }
    if (per_page > 0) {
      params = params.set('per_page', per_page.toString());
    }
    if (join_verifiers) {
      params = params.set('join_verifiers', join_verifiers.toString());
    }
    if (join_parents) {
      params = params.set('join_parents', join_parents.toString());
    }
    if (role_fields) {
      params = params.set('role_fields', role_fields.toString());
    }
    if (is_active) {
      params = params.set('is_active', is_active.toString());
    }
    if (is_login) {
      params = params.set('is_login', is_login.toString());
    }
    if (source) {
      params = params.set('source', source);
    }
    return this.httpClient
      .get<RoleResponse>(role_urls.get_roles, { params, ...httpOptions })
      .pipe(
        shareReplay(),
        map((response: any): RoleResponse => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body.data,
            success: response.body.data,
          };
        }),
      );
  }

  getRoleFields(id: number): Observable<HttpRes> {
    return this.httpClient
      .get<HttpRes>(role_urls.get_role_fields + '?role_id=' + id, httpOptions)
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body,
            success: response.body.data,
          };
        }),
      );
  }

  //getting User Roles
  getUserRole(id: number): Observable<HttpRes> {
    const switchId = this.getSwitchUserRoleIdForQuery();
    let userRoleId = id;
    if (switchId) {
      const n = Number.parseInt(switchId, 10);
      if (!Number.isNaN(n) && n >= 0) {
        userRoleId = n;
      }
    }
    return this.getUserRoleById(userRoleId);
  }

  getUserRoleById(userRoleId: number): Observable<HttpRes> {
    const params = new HttpParams().set('user_role_id', String(userRoleId));
    return this.httpClient
      .get<HttpRes>(role_urls.user_role, { params, ...httpOptions })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body.data,
          } as any;
        }),
      );
  }

  //update user role

  updateUserRole(user_role_id: number, user_data: any) {
    return this.httpClient
      .put<HttpRes>(
        role_urls.update_user_role + '?user_role_id=' + user_role_id,
        user_data,
        httpOptions,
      )
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body,
          } as any;
        }),
      );
  }

  fileUpload(formData: any) {
    const reqHeader = new HttpHeaders({
      enctype: 'multipart/form-data',
      auth:
        'Bearer ' +
        (globalThis.window?.localStorage
          ? localStorage.getItem('token')
          : ''),
    });
    return this.httpClient
      .post(environment.apiUrl + 'file_upload?path=UserProfile', formData, {
        headers: reqHeader,
        params: {},
        observe: 'response' as const,
      })
      .pipe(
        map((response: any): HttpRes => {
          return response;
        }),
      );
  }

  get_role_parents(id: number): Observable<HttpRes> {
    return this.httpClient
      .get<HttpRes>(role_urls.get_role_parents + '?role_id=' + id, httpOptions)
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body,
          } as any;
        }),
      );
  }
  // toast(meassage: string, type: string) {
  //   this.snack_bar.open(meassage, 'close', {
  //     duration: this.durationInSeconds,
  //     panelClass: [type],
  //   });
  //   sb.onAction().subscribe(() => {
  //     sb.dismiss();
  //   });
  // }

  eligibleRolesForRegistration(
    feature_id: any,
    feature_group_id: any,
    feature_ids?: any,
  ) {
    let params = new HttpParams();
    if (feature_id > 0) {
      params = params.set('feature_id', feature_id.toString());
    }
    if (feature_group_id > 0) {
      params = params.set('feature_group_id', feature_group_id.toString());
    }
    if (feature_ids > 0) {
      params = params.set('feature_ids', feature_ids.toString());
    }
    return this.httpClient
      .get<HttpRes>(role_urls.eligible_roles_registration, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body,
          };
        }),
      );
  }

  get_roles_entity(role_id: number): Observable<HttpRes> {
    const params = new HttpParams().set('role_id', role_id); // Add role_id to params

    return this.httpClient
      .get<HttpRes>(role_urls.get_role_parents, { params, ...httpOptions })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body.data,
          };
        }),
      );
  }

  get_children_hierarchy(
    user_role_id: number,
    role_id: number,
    page_num: number,
    per_page: number,
    ott_published: any = null,
    fetch_membership_users: boolean | null = null,
    include_user_profile: boolean | null = null,
    search: string = '',
  ): Observable<HttpRes> {
    let params = new HttpParams()
      .set('role_id', role_id)
      .set('user_role_id', user_role_id)
      .set('page_num', page_num)
      .set('per_page', per_page);
    if (ott_published !== null) {
      params = params.set('ott_publish', ott_published);
    }
    if (fetch_membership_users !== null) {
      params = params.set('fetch_membership_users', fetch_membership_users);
    }
    if (include_user_profile !== null) {
      params = params.set('include_user_profile', include_user_profile);
    }
    if (search !== '' || search !== null) {
      params = params.set('search_value', search);
    }
    return this.httpClient
      .get<HttpRes>(role_urls.get_children_hierarchy, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body.data,
            count: response.body.count,
          };
        }),
      );
  }

  getDashboardData(
    user_role_id: number,
    role_id: number,
  ): Observable<HttpRes> {
    const params = new HttpParams()
      .set('role_id', role_id)
      .set('user_role_id', user_role_id);
    return this.httpClient
      .get<HttpRes>(role_urls.get_dashboard_data, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body,
            success: response.body.data,
          };
        }),
      );
  }

  getRegistrationSettings(
    event_id: number,
    category_id: number,
  ): Observable<HttpRes> {
    const params = new HttpParams()
      .set('event_id', event_id)
      .set('category_id', category_id); // Add role_id to params

    return this.httpClient
      .get<HttpRes>(role_urls.get_category_registration_settings, {
        params,
        ...httpOptions,
      })
      .pipe(
        shareReplay(),
        map((response: any): HttpRes => {
          return {
            code: response.status,
            msg: response.body.msg,
            data: response.body.data,
          };
        }),
      );
  }
}
